import { STATIC_STORAGE_URL } from '@nexxt/common/constants';
import * as React from 'react';
import NotifyHOC from '../../HOC/Notifications';
import RollbarHOC from '../../HOC/Rollbar';
import { sendFeedback } from '../../services/client.service';

interface WorskapeceErrorBoundaryProps {
    children: React.ReactNode;
    toastNotification: any;
    rollbar: any;
}

interface WorskapeceErrorBoundaryState {
    hasError: boolean;
    feedbackInput: string;
    errorMessage: string;
    errorInfo: any;
}

class ProjectBuilderError extends React.Component<
    WorskapeceErrorBoundaryProps,
    WorskapeceErrorBoundaryState
> {
    state = {
        hasError: false,
        feedbackInput: '',
        errorMessage: '',
        errorInfo: {}
    };

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.props.rollbar.error(`[PORTAL]: ${error}`);
        this.setState({ errorInfo, errorMessage: error.message });
    }

    handleFeedbackChange = (e) => {
        this.setState({
            feedbackInput: e.target.value
        });
    };

    submitFeedback = async () => {
        const { feedbackInput, errorMessage, errorInfo } = this.state;
        const { toastNotification } = this.props;

        try {
            if (feedbackInput === '') {
                toastNotification.error(
                    'Please enter your message into the text field.'
                );
            } else {
                await sendFeedback({
                    message: feedbackInput,
                    subject: 'Error Detected in Project Builder',
                    error: {
                        message: errorMessage,
                        info: errorInfo
                    }
                });

                location.reload();
            }
        } catch (error) {
            toastNotification.error(
                'Failed to send feedback. Refresh and try again.'
            );
        }
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="err-container">
                    <div className="err-container--column">
                        <img
                            src={`${STATIC_STORAGE_URL}/img/portal/illustrates/portal-error.gif`}
                            alt="Error Illustration"
                        />
                        <h1>Something went wrong.</h1>
                        <h2>The site crashed. Let’s look into it.</h2>
                    </div>
                    <div className="err-container--column">
                        <h3>Leave your feedback</h3>
                        <p>
                            What was going on right before the site crashed? Has
                            this happened before? Let us know below.
                        </p>
                        <textarea
                            className="feedback-input"
                            placeholder="What's going on?"
                            onChange={this.handleFeedbackChange}
                        />
                        <button
                            className="btn btn--sm btn--green"
                            type="submit"
                            onClick={this.submitFeedback}
                        >
                            Submit and Refresh Page
                        </button>
                        <span>
                            If you have already submitted a report, just{' '}
                            <a href="">refresh the page</a>.
                        </span>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default NotifyHOC(RollbarHOC(ProjectBuilderError));
